import { api as apApi } from './index';

export const fetchDocumentTemplates = (orgId) => {
  return apApi.get(`/api/organization/${orgId}/document_templates`);
};

export const createDocument = (orgId, payload) => {
  return apApi.post(`/api/organization/${orgId}/documents`, payload);
};

export const createDocumentFromTemplate = (orgId, payload) => {
  return apApi.post(`/api/organization/${orgId}/documents?create_from_template`, payload);
};

export const deleteDocument = (orgId, documentId) => {
  return apApi.delete(`/api/organization/${orgId}/documents/${documentId}`);
};

export const createDocumentComment = (orgId, documentId, comment) => {
  const payload = {
    body: comment,
  };
  return apApi.post(`/api/organization/${orgId}/documents/${documentId}/comments`, payload);
};
